var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgExchangeIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1145_8224)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 18.1372V11.2565L1.85911 8.18114L1.32911 8.71115L1.3238 8.71646L1.31838 8.72166C1.13867 8.89432 0.995677 9.10151 0.898 9.33077L0.898 9.33077C0.800349 9.55996 0.75 9.80664 0.75 10.0558C0.75 10.305 0.800331 10.5516 0.898 10.7809L8 18.1372ZM8 18.1372L1.33171 11.4031L1.32509 11.3964L1.31832 11.3899C1.13868 11.2173 0.995706 11.0102 0.898027 10.781L8 18.1372Z",
    stroke: "#535C64",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6683 11.4031L12 18.1372V11.2565L18.1409 8.18114L18.6709 8.71115L18.6762 8.71643L18.6816 8.7216C18.8613 8.89434 19.0044 9.10157 19.102 9.33075C19.1997 9.55995 19.25 9.80663 19.25 10.0558C19.25 10.305 19.1997 10.5516 19.102 10.7809C19.0044 11.0101 18.8613 11.2173 18.6816 11.39L18.6749 11.3964L18.6683 11.4031Z",
    stroke: "#535C64",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3858 1.31562L11.3858 1.31567L11.393 1.32291L15.2569 5.19727L10.025 7.79303L4.82825 5.19972L8.70435 1.32363L8.70441 1.32369L8.71229 1.31556C8.88594 1.1366 9.0937 0.994339 9.32329 0.897205C9.5529 0.800059 9.7997 0.75 10.0491 0.75C10.2983 0.75 10.5451 0.800054 10.7747 0.897205L11.0652 0.210585L10.7747 0.897205C11.0043 0.994337 11.2121 1.1366 11.3858 1.31562Z",
    stroke: "#535C64",
    strokeWidth: 1.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1145_8224"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExchangeIcon);
export default __webpack_public_path__ + "static/media/exchange-icon.36f3750d7140e5294b617c352100caef.svg";
export { ForwardRef as ReactComponent };